import { memo } from 'react';

import { Icons, IconType } from '../../../constants/icons';
import { AvatarNode, AvatarProps } from '../AvatarNode';
import { JoyajoyImage } from '../JoyajoyImage';

import './ListModalItem.css';

export enum ListModalItemType {
  Normal = 'normal',
  Classroom = 'classroom',
}

interface BaseListItem {
  type: ListModalItemType;
  onPress: (id: string) => void;
}

export interface NormalListItem {
  type: ListModalItemType.Normal;
  id: string;
  icon?: string;
  text: string;
}

export interface ClassroomListItem {
  type: ListModalItemType.Classroom;
  id: string;
  icon: string;
  text: string;
  avatar: AvatarProps;
  userName: string;
  isVerified?: boolean;
}

export type ListModalItemProps = BaseListItem &
  (NormalListItem | ClassroomListItem);

export const ListModalItem = memo((props: ListModalItemProps) => {
  if (props.type === ListModalItemType.Normal) {
    const { id, icon, text, onPress } = props;
    return (
      <div className="list-modal-item">
        <div className="list-item-container" onClick={() => onPress(id)}>
          {icon && <JoyajoyImage resource={{ uri: icon }} className={'icon'} />}
          <p className="item-text">{text}</p>
        </div>
      </div>
    );
  } else if (props.type === ListModalItemType.Classroom) {
    const { id, icon, onPress, text, avatar, userName, isVerified } = props;
    return (
      <div className="list-modal-item">
        <div className="list-item-container" onClick={() => onPress(id)}>
          <div className="content">
            <JoyajoyImage resource={{ uri: icon }} className={'small-image'} />
            <div>
              <p className="first-text">{text}</p>
              <div className="third-text">
                <AvatarNode avatar={avatar} />
                {userName}
                {isVerified && (
                  <img className="right-icon" src={Icons[IconType.Certified]} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
});
